import { IS_SP } from '~/const/config';
import globalResize from '~/util/globalResize';

/**
 * モーダル コンテンツ
 */

export class ModalContents {
  constructor(el) {
    this.DOM = {};
    this.DOM.openBtn = el;
    this.DOM.closeBtn = document.querySelector('.js-popup-closeBtn');
    this.DOM.modal = document.querySelector('.js-popup');
    this.DOM.modalContents =
      this.DOM.modal?.querySelector('.js-popup-contents');
    this.DOM.popupBodys = document.querySelectorAll('.js-popup-body');
    this.onInit();
  }
  onInit() {
    if (
      !this.DOM.openBtn ||
      !this.DOM.closeBtn ||
      !this.DOM.modal ||
      !this.DOM.modalContents
    )
      return;

    this.DOM.openBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this._toggleModal(true);
    });

    this.DOM.closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this._toggleModal(false);
    });

    this.DOM.modal.addEventListener('click', (e) => {
      if (e.target === this.DOM.modal) {
        e.preventDefault();
        this._toggleModal(false);
      }
    });

    this.DOM.modalContents.addEventListener('click', (e) => {
      e.stopPropagation();
    });

    this.onResize = () => this._onResize();
    this.onResize();
    globalResize.addEvent(this.onResize);
  }
  _onResize() {
    if (IS_SP) {
      this._toggleModal(false);
    }
  }
  _toggleModal(isOpen) {
    this.DOM.modal.classList.toggle('is-open', isOpen);

    const dataId = this.DOM.openBtn.dataset.id;
    const no = dataId.replace(/popup-(\d+)/, "$1");
    if (no > 0 && no <= this.DOM.popupBodys.length) {
      if (isOpen) {
        this.DOM.popupBodys[no - 1].classList.add('is-open');
      } else {
        this.DOM.popupBodys[no - 1].classList.remove('is-open');
      } 
    }
  }
}
